module.exports = __webpack_public_path__ + "img/4LOG.e0959107.png";